import { Component, input, output } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import { formatCurrencyAmount } from '../../../service-step/sections/delivery-service-selection/delivery-service-matrix';
import type { ReviewAdditionalServicesView } from '../../utils/map-review-additional-services';
import { ReviewDetailCard } from '../review-detail-card/review-detail-card';

/**
 * Additional Services summary card (declared value + selected signature).
 */
@Component({
  selector: 'app-review-additional-services-summary',
  imports: [ReviewDetailCard, TranslatePipe, TypographyComponent],
  templateUrl: './review-additional-services-summary.html',
  styleUrl: './review-additional-services-summary.scss',
})
export class ReviewAdditionalServicesSummary {
  readonly view = input.required<ReviewAdditionalServicesView>();
  /** When false, hides Edit (Get Labels confirmation). */
  readonly showEdit = input(true);
  readonly editRequested = output<string>();

  protected readonly formatCurrencyAmount = formatCurrencyAmount;
}
